<main class="w-100 h-100 p-2">

    <section class="container border border-2 border-daanger p-md-4 p-2 ">

        <h1 class="fw-bold"> اعتبار سنجی جرثقیل </h1>

        <p class="fs-6"> در این قسمت اطلاعات کاملی از جرثقیل اعم از سیار و یا ثابت شامل مشخصات فنی، سوابق کاری، بازرسی
            های فنی و ... را
            می توانید مشاهده کنید. برای این منظور لطفا کد 6 رقمی جرثقیل درج شده بر روی بدنه خودرو و یا جرثقیل را وارد و
            سپس
            دکمه بررسی را انتخاب کنید.
        </p>

        <div [formGroup]="mdl_Validate" class="row gx-0 gy-2 w-100 p-2">

            <div class="col-12 col-md-5">

                <div class="form-group w-100 has-icon">

                    <span class="form-control-icon"> 

                        <mat-icon aria-hidden="true">car_crash</mat-icon>

                    </span>
    
                    <input (input)="filterNumericInput($event)" inputmode="numeric" 

                        formControlName="strCode"
                    
                        placeholder="کد جرثقیل را وارد کنید"

                        maxlength="6" class="form-control">
    
                </div>

            </div>

            <div class="col-12 col-md-auto px-md-2">

                <button class="w-100 btn btn-primary" (click)="checkOut_Truck()">

                    &nbsp; بررسی کد &nbsp;
                    
                </button>

            </div>

            <!-- اطلاعات امدادگر -->

            <ng-container *ngIf="information_ads?.strFullName">
                
                <div class="col-12 mt-3 border-top">

                    <!-- اطلاعات آگهی -->

                    <section class="main-container row w-full gx-2 p-2">

                        <!-- اطلاعات سمت راست -->

                        <div class="col-12 col-md-6 p-2">

                            <div  class="w-100 h-100 p-2">

                                <!-- عنوان -->

                                <h1 class="fw-bold mb-2 pb-3 border-bottom d-flex justify-content-between align-items-center" style="pointer-events: none;"> 
                                    
                                    <span> {{ information_ads.strFullName }} </span>

                                    <ngx-star-rating formControlName="rating1"></ngx-star-rating>
                                
                                </h1>

                                <!-- کد جرثقیل -->

                                <!-- دکمه ها -->

                                <div class="ads-operation w-100 d-flex justify-content-between py-2">

                                    <div class="buttons-container d-flex">

                                        <!-- شماره تماس -->

                                        <div class="ads-call">

                                            <button class="btn btn-call central px-4 pointer" (click)="show_Warning_Before_Call()" [disabled]="information_ads?.strMobile">

                                                <mat-icon>call</mat-icon>

                                                <span class="mx-2"> تماس </span>

                                            </button>

                                        </div>

                                        <!-- گزارش -->

                                        <div class="ads-call mx-2">

                                            <button class="btn text-white central px-md-4 px-2 pointer" style="background-color: #5c636a;border-color: #565e64;" (click)="goTo_Support()">

                                                <mat-icon>warning</mat-icon>

                                                <span class="mx-2"> گزارش  </span>

                                            </button>

                                        </div>

                                    </div>

                                    <div class="ads-share-bookmark d-flex align-items-center justify-content-end w-25">

                                        <span class="d-flex material-symbols-outlined" (click)="shareVia()">

                                            <mat-icon class="mat-18 text-muted pointer">share</mat-icon>

                                        </span>


                                    </div>

                                </div>

                                <!-- اطلاعات آگهی گذار -->

                                <div [@slideInOut]="information_ads?.strMobile ? 'open' : 'closed'" class="ads-address-number-show w-100 p-2 mt-2">

                                    <div class="d-flex justify-content-between mb-4">

                                        <span> شماره موبایل </span>

                                        <div class="d-flex align-items-center pointer" (click)="callWith_advertiser()">

                                            <span class="mx-2"> {{ information_ads?.strMobile | faNum }} </span>

                                            <span class="d-flex material-symbols-outlined">

                                                <mat-icon class="mat-18 text-muted">phone_in_talk</mat-icon>

                                            </span>

                                        </div>

                                    </div>

                                    <div style="background-color: #F0FAFF;" class="rounded-sm p-3 ">

                                        <p class="fw-bold"> هشدار </p>

                                        <span class="text-muted"> لطفاً پیش از انجام معامله و هر نوع پرداخت وجه، از صحت خودرو یا خدمات ارائه‌شده، به‌صورت حضوری اطمینان حاصل نمایید. </span>

                                    </div>

                                </div>

                                <!-- اطلاعات عمودی -->

                                <div class="ads-vertical p-4">

                                    <div *ngFor="let item of information_ads.lstHorizontalInfo;let i = index;" [ngClass]=" true ? 'ads-info-' + (i+1) : '' " class="text-center col-4">

                                        <span [innerHTML]="getSafeHtml(item.strTitle)" class="text-muted"> {{ item.strTitle || ' ' }} </span>

                                        <h2 class="mb-0" style="line-height: initial!important;">

                                            <span [innerHTML]="getSafeHtml(item.strValue)" class="text-dark fw-bold">
                                            
                                                {{ (item.strValue | faNum) || ' '}}
                                            
                                            </span>


                                        </h2>

                                    </div>

                                </div>

                                <!-- اطلاعات افقی -->

                                <ng-container class="ads-horizontal" *ngFor="let item of information_ads.lstverticalInfo;let i = index;">

                                    <div class="ads-horizontal w-100 d-flex justify-content-between mt-2 p-2">

                                        <span [innerHTML]="getSafeHtml(item.strTitle)" class="text-muted"> {{ item.strTitle || ' ' }} </span>

                                        <span [innerHTML]="getSafeHtml(item.strValue | faNum)" class="text-dark fw-bold"> {{( item.strValue | faNum ) || ''}} </span>

                                    </div>

                                    <hr class="ads-divider m-0 w-100">

                                </ng-container>

                            </div>

                        </div>

                        <!-- اطلاعات سمت چپ -->

                        <div class="col-12 col-md-6 h-100 p-2">

                            <div class="w-100 h-100 p-2">
                
                                <div class="ads-images-container h-65">

                                    <!-- عکس اصلی -->

                                    <div class="ads-images-preview h-75">

                                        <div class="position-relative w-full h-100 rounded">

                                            <img class="w-100 h-100 rounded" [src]="information_ads?.list_Gallery?.[0] ? 'data:image/jpeg;base64,' + information_ads.list_Gallery[0] : '../../../assets/imgs/preview__thumbnail.png'" [alt]="information_ads?.strFullName || 'Image preview'">
                
                                            <span *ngIf="information_ads?.list_Gallery.length > 0" class="position-absolute pointer" (click)="openGallery(information_ads?.list_Gallery?.[0],0)"> 
                                                
                                                <mat-icon> fullscreen </mat-icon>
                
                                                {{ information_ads?.list_Gallery.length | faNum }}
                                            
                                            </span>
                
                                        </div>

                                    </div>

                                    <!-- بقیه تصاویر -->

                                    <div *ngIf="information_ads?.list_Gallery.length > 1" class="ads-images-all w-full row dil gx-2 pt-1 h-25">

                                        <div *ngFor="let item of list_AdsImagesShown;let i = index" class="ads-image col-md-4 col-6 p-2">

                                            <div class="w-full h-100 rounded position-relative" (click)="openGallery(item,i)">

                                                <ng-container *ngIf=" i == 0">

                                                    <div *ngIf="list_AdsImagesCounter > 0" class="pic-counter pointer">

                                                        +{{ list_AdsImagesCounter | faNum }}

                                                    </div>

                                                </ng-container>

                                                <img class="w-100 h-100 rounded" src="{{'data:image/jpeg;base64,' + item}}" [alt]="information_ads?.strTitle">

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </section>

                </div>

            </ng-container>

            <!-- ثبت نظر -->

            <ng-container *ngIf="information_ads?.strFullName">

                <div class="col-12 row gx-0 gy-3 p-2 mt-3">

                    <h2 class="col-12">دیدگاه خود را بنویسید</h2>

                    <!-- نام و نام خانوادگی -->

                    <div class="col-md-6 col-12 px-md-2 px-0">

                        <div class="form-group w-100 has-icon">

                            <span class="form-control-icon"> 
        
                                <mat-icon aria-hidden="true">person</mat-icon>
        
                            </span>
            
                            <input placeholder="نام و نام خانوادگی" class="form-control">
            
                        </div>

                    </div>

                    <!-- ایمیل -->

                    <div class="col-md-6 col-12 px-md-2 px-0">

                        <div class="form-group w-100 has-icon">

                            <span class="form-control-icon"> 
        
                                <mat-icon aria-hidden="true">alternate_email</mat-icon>
        
                            </span>
            
                            <input placeholder="ایمیل" class="form-control">
            
                        </div>

                    </div>

                    <!-- دیدگاه کاربر -->

                    <div class="col-12 px-md-2 px-0">

                        <textarea style="height: 150px;" class="w-100 form-control" placeholder="دیدگاه خود را درباره این امدادگر بنویسید..."></textarea>

                    </div>

                    <div class="col-12 px-md-2 px-0 text-start">

                        <button class="btn btn-success"> ثبت دیدگاه </button>

                    </div>

                </div>

            </ng-container>

            <!-- نظرات کاربران -->

            <ng-container *ngIf="information_ads?.strFullName">

                <div class="col-12 px-md-2 px-0 mt-3 border-top pt-3">

                    <h3 class="fw-bold"> نظرات کاربران ({{ information_ads.lstComments.length | faNum }})</h3>

                    <div class="w-100 p-md-5 p-0" style="background-color: #F5F5F5;">

                        <div class="p-2">

                            <ng-container *ngFor="let item of information_ads.lstComments">

                                <div class="hangout-comment comment-body px-1 mb-5">
        
                                    <!-- تصویر کامنت گذار  -->
        
                                    <div class="comment-avatar col-auto">
            
                                        <img src="{{ item?.strImage && item.strImage != '' ? 'data:image/jpeg;base64,' + item.strImage  : '../../../assets/imgs/user_profile.png' }}" [alt]="item?.strFullName">
            
                                    </div>
        
                                    <!-- اسم کامنت گذار -->
        
                                    <div class="comment-name col-auto">
        
                                        <span class="mx-2"> {{item.strNikName || 'کاربر امدادران'}} </span>
        
                                        <span style="font-size: 12px;" class="text-muted"> {{ item.strDate  || '1403/11/08' | faNum }} </span>
        
                                    </div>
        
                                    <!-- متن کامنت گذار -->
        
                                    <div class="comment-content col-12">
        
                                        <span style="font-size: 12px;"> {{item.strComment || item }} </span>
                                        
                                    </div>
            
                                </div>

                            </ng-container>

                        </div>

                    </div>

                </div>

            </ng-container>

        </div>

        <!-- گالری تصاویر -->

        <div class="modal fade dir" id="galleryComp_Modal" role="dialog" style="z-index: 1000!important;">

            <div class="modal-dialog modal-fullscreen modal-dialog-centered">

                <div class="modal-content">

                    <div class="modal-header d-flex justify-content-between">

                        <h3 class="modal-title mb-0"> گالری تصاویر </h3>

                        <button type="button" class="btn-close p-0 m-0" data-bs-dismiss="modal"></button>

                    </div>

                    <div class="modal-body">

                        <ng-container *ngIf="isAlbum">

                            <custom-gallery 
                            
                                [albumIndex]="albumIndex"

                                [lst_Album]="lst_Album"

                                [isDownloadAble]="false"
                                
                                [strKey_list]="'strImage'">
                        
                            </custom-gallery>
                            
                        </ng-container>

                    </div>

                </div>

            </div>

        </div>

    </section>

</main>